import { render, staticRenderFns } from "./WorkflowSequenceHeader.vue?vue&type=template&id=6639a865&"
import script from "./WorkflowSequenceHeader.vue?vue&type=script&lang=js&"
export * from "./WorkflowSequenceHeader.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowSequenceHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports